import { render, staticRenderFns } from "./PaieskaRegistruoti.vue?vue&type=template&id=e6355628&scoped=true&"
import script from "./PaieskaRegistruoti.vue?vue&type=script&lang=js&"
export * from "./PaieskaRegistruoti.vue?vue&type=script&lang=js&"
import style0 from "./PaieskaRegistruoti.vue?vue&type=style&index=0&id=e6355628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6355628",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VDataTable,VIcon})
